var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Backbone = require('dibs-backbone');

'use strict';

var AlertView;

/**
 * @class AlertView
 * @extends Backbone.View
 *
 * Simple standardized view to render an alert DOM element
 *
 * @param {object} [options]
 * @param {string} [options.alert]
 *      The message to display
 * @param {string} [options.type]
 *      The kind of alert, can be an 'info', 'success', or an 'error' alert
 * @param {object} [options.config]
 * @param {boolean} [options.config.close]
 *      Whether the user is allowed to close the alert message or not
 * @param {boolean} [options.config.animate]
 *      Whether the alert message should be animated, true by default
 * @param {number} [options.config.autoClose]
 *      The number of milliseconds before automatically closing
 * @param {boolean} [options.config.noDefaultClasses]
 *      If true, will not add classes: 'alert alert-' + alert.type
 */
AlertView = Backbone.View.extend({

    template: _.template("<% if (obj.close) { %><button type='button' class='close' data-dismiss='alert'><span aria-hidden='true'><i class='fa fa-times'></i></span></button><% } %><%= obj.message %> <% _.each(obj.actions, function (v, k) { %> <span class='alert-action' data-action='<%- k %>'><%- v %></span><% }) %>"),

    initialize: function (options) {
        var events = {};
        this.alert = _.extend({
            type: 'info ',
            message: typeof options.alert === "string" ? options.alert : _.result(options.alert, 'responseText')
        }, _.pick(options, 'type', 'actions'));
        this.config = _.extend({ // default config
            animate: false,
            close: false,
            autoClose: 0,
            noDefaultClasses: false
        }, _.result(options, 'config'));
        if (this.config.close) {
            events['click .close'] = this.close;
        }
        // alias reset
        this.reset = this.resetMessage;
        this.actionEvents = _.reduce(options.actions, function (memo, value, actionKey) {
            memo['click [data-action=' + actionKey + ']'] = value.click;
            return memo;
        }, {});
        this.alert.actions = _.reduce(options.actions, function (memo, value, actionKey) {
            memo[actionKey] = value.label;
            return memo;
        }, {});
        this.delegateEvents(_.extend(events, options.events, this.actionEvents));
    },

    render: function () {
        var defaultClasses = 'alert alert-' + this.alert.type;
        var classes = (this.config.class) ? '' + this.config.class : '';
        var dataTn = 'alert-' + this.alert.type;

        if (!this.config.noDefaultClasses) {
            classes += ' ' + defaultClasses;
        }

        this.$el
            .html(this.template(_.extend(_.pick(this.config, 'close'), this.alert)))
            .attr('class', '')
            .attr('data-tn', dataTn)
            .addClass(classes);

        // If the user wants this alert div to be animated, then set the height and opacity to zero
        if (this.config.animate) {
            this.el.style.display = "none";
        }
        return this;
    },

    /**
     * Animates the element to expand it's container, then fade in
     * @param {function} after
     *      optional callback function after animation is complete
     * @memberOf AlertView#
     * @returns {AlertView}
     */
    slideFadeIn: function (after) {
        var that = this,
            height,
            padding,
            border = parseInt(that.$el.css("border-top-width"), 10) +
                parseInt(that.$el.css("border-bottom-width"), 10);

        that.$el.css({ display: 'block' });

        height = that.$el.height();
        padding = (that.$el.innerHeight() - height) / 2;

        that.$el.css({
            height: 0,
            opacity: 0,
            paddingTop: 0,
            paddingBottom: 0
        });

        that.animDfd = $.Deferred();
        that.$el.animate({
            height: height + (padding * 2) + border, // add padding since this is box-sizing border-box
            paddingTop: padding,
            paddingBottom: padding
        }, 300, function () {
            that.$el.animate({
                opacity: 1
            }, 200, function () {
                that.animDfd.resolve();
                that.$el.css('height', 'auto');
                if ($.isFunction(after)) {
                    after.apply(that);
                }
            });
        });

        this.setAutoClose();

        return this;
    },

    /**
     * Animate the element to fade out and then contract the element
     * until it's height is zero, used as the default close animation
     * @param after {Function}
     *      callback function after the animation is complete
     * @memberOf AlertView#
     * return {AlertView}
     */
    slideFadeOut: function (after) {
        var that = this;

        that.$el.animate({ opacity: 0 }, 200, function () {
            that.$el.slideToggle(300, function () {
                that.$el.removeAttr('style');
                that.$el.hide();
                if ($.isFunction(after)) {
                    after.apply(that);
                }
            });
        });
        return this;
    },

    /**
     * Display the alertView. Animates if
     * config.aminate is true
     * @memberOf AlertView#
     * @returns {AlertView}
     */
    open: function () {
        var self = this;

        if (this.config.animate) {
            this.slideFadeIn();
        } else {
            this.$el.show();
        }

        self.setAutoClose();

        return this;
    },

    /**
     * Hide the AlertView
     * @memberOf AlertView#
     * @return {Object} AlertView
     */
    close: function (event) {
        if (event) {
            event.stopPropagation();
        }

        if (typeof this.config.onClose === "function") {
            this.config.onClose.call(this);
        }

        if (this.config.animate) {
            this.slideFadeOut(this.remove);
        } else {
            this.$el.hide();
        }

        return this;
    },

    /**
     * Auto close the alertView after
     * config.autoClose time ms
     * @memberOf AlertView#
     */
    setAutoClose: function () {
        var self = this;
        if (self.timeout) {
            clearTimeout(self.timeout);
        }
        if (self.config.autoClose !== 0) {
            self.timeout = setTimeout(function () {
                self.$el.fadeOut(function () {
                    self.close();
                });
            }, self.config.autoClose);
        }
    },

    /**
     * @memberOf AlertView#
     * @param {string} newMessage
     * @param {string} newType
     */
    resetMessage: function (newMessage, newType) {
        this.$el.show();
        $.when(this.animDfd).done($.proxy(function () {
            if (this.config.animate) {
                this.animDfd = $.Deferred();
                this.$el.animate({opacity: 0}, $.proxy(function () {
                    this.alert.message = newMessage;
                    this.$el
                        .html(this.template(_.extend(_.pick(this.config, 'close'), this.alert)))
                        .removeClass('alert-' + this.alert.type)
                        .addClass('alert-' + newType)
                        .animate({ opacity: 1 }, this.animDfd.resolve());
                    this.alert.type = newType;
                }, this));
            } else {
                this.alert.message = newMessage;
                this.alert.type = newType;
                this.render();
            }
        }, this));
        this.setAutoClose();
    }
});

module.exports = AlertView;



//////////////////
// WEBPACK FOOTER
// ./~/dibs-alert-view/index.js
// module id = 693
// module chunks = 4 6 7 8 9 13 17